import { components, services } from '@/utils'

export default function(h) {
  if (this.tabs.length > 1) {
    return h(
      components['tabs-header'],
      {
        props: {
          value: this.proxy,
          tabs: this.tabs.map(tab => {
            return {
              key: tab,
              title: this.getTranslate(`${services.sendings}.tabs.${tab}`)
            }
          })
        },
        on: {
          input: event => {
            this.proxy = event
          }
        },
        slot: 'header'
      }
    )
  }
}
